import React from "react";
import styled from "styled-components";

const SparePartOrderReview = ({
  className,
  totalPriceFormatted,
  totalItemsCount
}) => {
  return (
    <div className={className}>
      <div className="order-review-wrapper">
        <div className="order-review-container">
          <div className="left-section">
            <h3 className="order-review-title">Order Review</h3>
            <p className="order-review-subtitle">
              Review and adjust quantities before submitting your order
            </p>
          </div>

          <div className="right-section">
            <div className="total-items">
              <span className="label">Total Items</span>
              <span className="value">{totalItemsCount || 0}</span>
            </div>

            <div className="separator" />

            <div className="total-amount">
              <span className="label">Total Amount</span>
              <span className="value">{totalPriceFormatted || "0.00"}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const StyledSparePartOrderReview = styled(SparePartOrderReview)`
  margin-bottom: 16px;

  .order-review-wrapper {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 18px 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  }

  .order-review-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;
    }
  }

  .left-section {
    flex: 1;

    .order-review-title {
      font-size: 18px;
      font-weight: 600;
      color: #1a1a1a;
      margin: 0 0 4px;
      line-height: 1.2;
    }

    .order-review-subtitle {
      font-size: 14px;
      font-weight: 400;
      color: #6b7280;
      margin: 0;
      line-height: 1.4;
    }
  }

  .right-section {
    display: flex;
    align-items: center;
    overflow: hidden;

    @media (max-width: 768px) {
      width: 100%;
      justify-content: space-between;
    }

    .total-items,
    .total-amount {
      min-width: 140px;
      text-align: center;

      .label {
        display: block;
        font-size: 12px;
        font-weight: 500;
        color: #6b7280;
        margin-bottom: 4px;
      }

      .value {
        display: block;
        font-size: 20px;
        font-weight: 700;
        color: #111827;
        line-height: 1;
      }
    }

    .separator {
      width: 1px;
      align-self: stretch;
      background-color: #e5e7eb;
    }
  }
`;

export default React.memo(StyledSparePartOrderReview);